import { PayloadAction } from '@reduxjs/toolkit';
import { plantApi } from 'api/plantApi';
import { itemParam, ListParams, ListResponse, plantInfo } from 'models';
import { call, put, takeLatest } from 'redux-saga/effects';
import { plantActions } from './plantSlice';

function* fetchPlantInfoSaga(action: PayloadAction<itemParam>) {
  try {
    const response: plantInfo = yield call(plantApi.fetchPlantInfo, action.payload);
    yield put(plantActions.fetchPlantInfoSuccess({ ...response, id: action.payload.id }));
  } catch (error) {
    yield put(plantActions.fetchPlantInfoFailed('fetch plant info failed'));
  }
}

function* fetchPlantListSaga(action: PayloadAction<ListParams>) {
  const { id, text, page_size, page } = action.payload;
  try {
    if (id) {
      let response: plantInfo[] = yield call(plantApi.getPlantsByUserId, id);
      yield put(plantActions.fetchPlantListSuccess(response));
    } else {
      let response: ListResponse<plantInfo> = yield call(plantApi.getPlantsList, {
        text: text,
        page_size: page_size,
        page: page,
      });
      yield put(plantActions.fetchPlantListSuccess(response.data));
    }
  } catch (error) {
    yield put(plantActions.fetchPlantListFailed('fetch Plant list failed'));
  }
}

export default function* plantSaga() {
  yield takeLatest(plantActions.fetchPlantInfo.type, fetchPlantInfoSaga);
  yield takeLatest(plantActions.fetchPlantList.type, fetchPlantListSaga);
}
